// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"347":"320844f0","787":"34eea1ec"}[chunkId] + ".chunk.js";
};